import { useCallback } from 'react';

export default function useSessionStorage() {
  const isBrowser = typeof window !== 'undefined';

  const getFromStorage = useCallback((key, defaultValue = null) => {
    if (!isBrowser) return defaultValue;

    try {
      const value = window.sessionStorage.getItem(key);
      return value !== null ? JSON.parse(value) : defaultValue;
    } catch (error) {
      console.error(`SessionStorage get error for key "${key}":`, error);
      return defaultValue;
    }
  }, []);

  const setToStorage = useCallback((key, value) => {
    if (!isBrowser) return;
    try {
      window.sessionStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      console.error(`SessionStorage set error for key "${key}":`, error);
    }
  }, []);

  const removeFromStorage = useCallback((key) => {
    if (!isBrowser) return;

    try {
      window.sessionStorage.removeItem(key);
    } catch (error) {
      console.error(`SessionStorage remove error for key "${key}":`, error);
    }
  }, []);

  const clearStorage = useCallback(() => {
    if (!isBrowser) return;

    try {
      window.sessionStorage.clear();
    } catch (error) {
      console.error('SessionStorage clear error:', error);
    }
  }, []);

  return {
    getFromStorage,
    setToStorage,
    removeFromStorage,
    clearStorage,
  };
}
